// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const QuestionCircle: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16">
            <path
                fill="#1E3160"
                transform="translate(0.357422 0)"
                d="M8 16C10.858125 16 13.499141 14.475208 14.928204 12C16.357265 9.5247917 16.357265 6.4752088 14.928204 4C13.499141 1.5247917 10.858125 0 8 0C5.1418753 0 2.5008588 1.5247917 1.0717964 4C-0.35726595 6.4752088 -0.35726595 9.5247917 1.0717964 12C2.5008588 14.475208 5.1418753 16 8 16ZM5.3062501 5.1656246C5.5531249 4.46875 6.2156253 4 6.9562502 4L8.7781248 4C9.8687496 4 10.75 4.8843746 10.75 5.9718752C10.75 6.6781254 10.371875 7.3312502 9.7593746 7.6843753L8.75 8.2624998C8.7437496 8.6687498 8.4093752 9 8 9C7.5843749 9 7.25 8.6656246 7.25 8.25L7.25 7.828125C7.25 7.5593748 7.3937502 7.3125 7.6281252 7.1781249L9.0124998 6.3843751C9.1593752 6.3000002 9.25 6.1437502 9.25 5.9750004C9.25 5.7124996 9.0375004 5.5031242 8.7781248 5.5031242L6.9562502 5.5031242C6.8500004 5.5031242 6.7562504 5.5687504 6.7218752 5.6687498L6.7093754 5.7062492C6.5718756 6.0968747 6.1406255 6.2999997 5.7531252 6.1624999C5.3656249 6.0250001 5.1593752 5.59375 5.296875 5.2062492L5.3093748 5.1687498L5.3062501 5.1656246ZM7 11C7 10.447715 7.4477153 10 8 10C8.5522852 10 9 10.447715 9 11C9 11.552285 8.5522852 12 8 12C7.4477153 12 7 11.552285 7 11Z"
            />
        </svg>
    );
};

export default React.memo(QuestionCircle);
